/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import './AppliedLetterTile.css';
import { Grid } from '@mui/material';
import { fonts, themes } from '../../themes/themes';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { LetterGenerationStatus } from '../../Modals/LetterGeneration/constants';
import { DateField } from '../../../components';
import { baseDateFormatting } from '../../helper';

interface contentTileType {
  ticketName: string;
  applicant: string;
  startDate: string | Date;
  endDate?: string | Date;
  status?: any;
  showViewBtn?: any;
  onClick?: any;
}
const AppliedLetterTile: React.FC<contentTileType> = ({
  ticketName,
  startDate,
  applicant,
  status,
  onClick,
  showViewBtn = true,
}) => {
  const { t } = useTranslation();
  const trans = t;
  return (
    <Grid container className="claim-history-AirTicket-container">
      <Grid item xs={10}>
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.title,
              fontFamily: fonts.fontFamily,
              color: themes.blackDefault,
              fontWeight: 'bold',
              textTransform: 'capitalize',
            }}
          >
            {ticketName}
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              textTransform: 'capitalize',
              letterSpacing: '0.01px',
              marginTop: '10px',
            }}
          >
            {trans('Applicant')} :
            <span
              style={{ color: themes.blackDefault, fontWeight: 700 }}
              className="mx-1"
            >
              {applicant}
            </span>{' '}
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              letterSpacing: '0.01px',
              marginTop: '5px',
              textTransform: 'capitalize',
            }}
          >
            {trans('Applied')} :
            <span
              style={{ color: themes.blackDefault, fontWeight: 700 }}
              className="mx-1"
            >
              <DateField value={startDate} format={baseDateFormatting} />
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              fontSize: '11px',
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              letterSpacing: '0.01px',
              textTransform: 'capitalize',
              marginTop: '5px',
              fontStyle: 'italic',
            }}
          >
            {trans('Status')} :
            {status == 0 ? (
              <span
                style={{ color: themes.defaultMisc, fontWeight: 700 }}
                className="mx-1"
              >
                {trans('Waiting for Approval')}
              </span>
            ) : status === LetterGenerationStatus.REJECTED ||
              status === LetterGenerationStatus.CANCELLED ? (
              <span
                style={{ color: themes.defaultError, fontWeight: 700 }}
                className="mx-1"
              >
                {trans(status.toLowerCase())}
              </span>
            ) : status === LetterGenerationStatus.APPROVED ? (
              <span
                style={{ color: themes.defaultSuccess, fontWeight: 700 }}
                className="mx-1"
              >
                {trans('Approved')}
              </span>
            ) : (
              <span
                style={
                  status === LetterGenerationStatus.CANCELLED ||
                  status === LetterGenerationStatus.REJECTED
                    ? { color: themes.defaultError, fontWeight: 700 }
                    : { color: themes.defaultSuccess, fontWeight: 700 }
                }
                className="mx-1"
              >
                {trans(status)}
              </span>
            )}
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        xs={2}
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-end',
          flexDirection: 'row',
        }}
      >
        {showViewBtn && (
          <Box className="icon-box_claim_AirTicket_history" onClick={onClick}>
            {' '}
            <i
              className="las la-eye"
              style={{
                color: themes.primaryMain,
              }}
            />{' '}
          </Box>
        )}
      </Grid>
    </Grid>
  );
};

export default AppliedLetterTile;
